const { components } = require("./components/index");
const { events } = require("./events/index");

const MRC2Section = {
  events,
  components
};

export { MRC2Section };